"use client";

import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { SectionItem } from "./SectionItem";
import type { SectionsOutput } from "@/interfaces/sections";
import type { OffersOutput } from "@/interfaces/offers";
import type {
  SectionItemOutput,
  SectionItemType,
} from "@/interfaces/section-items";
import type { ProductsOutput } from "@/interfaces/products";

interface SectionsListProps {
  sections: SectionsOutput[];
  offers: OffersOutput[];
  sectionItems: SectionItemOutput[];
  onAddSection: () => void;
  onMoveSection: (sectionId: string, direction: "up" | "down") => void;
  onToggleSectionVisibility: (sectionId: string) => void;
  onEditSection: (section: SectionsOutput) => void;
  onDeleteSection: (sectionId: string) => void;
  onAddOffer: (sectionId: string) => void;
  onToggleOfferVisibility: (offerId: string) => void;
  onDeleteOffer: (offerId: string) => void;
  onMoveOffer?: (offerId: string, direction: "up" | "down") => void;
  onAddSectionItem: (
    sectionId: string,
    itemId: string,
    itemType: SectionItemType,
    details?: ProductsOutput | OffersOutput
  ) => void;
  onToggleSectionItemVisibility: (itemId: string) => void;
  onDeleteSectionItem: (itemId: string) => void;
  onMoveSectionItem: (itemId: string, direction: "up" | "down") => void;
}

export function SectionsList({
  sections,
  offers,
  sectionItems,
  onAddSection,
  onMoveSection,
  onToggleSectionVisibility,
  onEditSection,
  onDeleteSection,
  onAddOffer,
  onToggleOfferVisibility,
  onDeleteOffer,
  onMoveOffer,
  onAddSectionItem,
  onToggleSectionItemVisibility,
  onDeleteSectionItem,
  onMoveSectionItem,
}: SectionsListProps) {
  return (
    <>
      <div className="space-y-4 mt-4">
        {sections?.length === 0 ? (
          <div className="text-center py-12 bg-gray-50 rounded-md border border-dashed">
            <p className="text-gray-500 mb-2">Nenhuma seção adicionada</p>
            <Button
              variant="default"
              className="bg-[#EE7B11] hover:bg-[#d06a0a]"
              onClick={onAddSection}
            >
              <Plus className="h-4 w-4 mr-2" />
              Adicionar Seção
            </Button>
          </div>
        ) : (
          sections?.map((section) => (
            <SectionItem
              key={section.id}
              section={section}
              offers={offers}
              sectionItems={sectionItems}
              totalSections={sections.length}
              onMoveSection={onMoveSection}
              onToggleVisibility={onToggleSectionVisibility}
              onEdit={onEditSection}
              onDelete={onDeleteSection}
              onAddOffer={onAddOffer}
              onToggleOfferVisibility={onToggleOfferVisibility}
              onDeleteOffer={onDeleteOffer}
              onMoveOffer={onMoveOffer}
              onAddSectionItem={onAddSectionItem}
              onToggleSectionItemVisibility={onToggleSectionItemVisibility}
              onDeleteSectionItem={onDeleteSectionItem}
              onMoveSectionItem={onMoveSectionItem}
            />
          ))
        )}
      </div>
    </>
  );
}
